module.exports = __webpack_public_path__ + "img/rightbtn.dcf846f9.png";